import { pickBy, identity } from "lodash"

/**
 * Request object for fetching advanced filtering filter options
 * 
 * @description Fetches available filter options (status_options, for_options, gender_options, etc.)
 * for the d6+ Advanced Filtering feature. Each entity type has its own endpoint:
 * - GET /portal/v1/advanced-filtering/parents/filters
 * - GET /portal/v1/advanced-filtering/learners/filters
 * - GET /portal/v1/advanced-filtering/staff/filters
 */
class GetAdvancedFilteringFiltersRequest {

    constructor({ 
        communityId,
    }) {
        this.communityId = communityId
    }

    getPayload = () => {
        
        const payload = {
            "community_id": this.communityId,
        }

        return pickBy(payload, identity)
    }
    
}

export default GetAdvancedFilteringFiltersRequest
